import { useState } from 'react'
import { useAppState } from './auth/useAppState'
import { SignInView } from './views/SignInView'
import { SettingsView } from './views/SettingsView'
import { PanelView } from './views/PanelView'

/**
 * The gate. The view is derived from auth + credential state — settings is what
 * you get until setup is done, not a page you navigate to. The one exception is
 * `forceSettings`, so a fully set-up user can still change a key.
 */
export default function App({ wide }: { wide?: boolean }) {
  const { status, me, missing, error, refresh } = useAppState()
  const [forceSettings, setForceSettings] = useState(false)
  const compact = !wide

  if (status === 'loading') {
    return <p className="sub">Loading…</p>
  }

  if (status === 'signed-out') {
    return <SignInView compact={compact} />
  }

  if (status === 'setup-required' || forceSettings) {
    return (
      <>
        {error && <div className="error">{error}</div>}
        <SettingsView
          me={me}
          missing={missing}
          compact={compact}
          refresh={refresh}
          onBack={forceSettings ? () => setForceSettings(false) : undefined}
        />
      </>
    )
  }

  // On the standalone /settings page there is no ticket, so show settings.
  if (wide) {
    return <SettingsView me={me} missing={missing} refresh={refresh} />
  }

  return (
    <PanelView
      me={me}
      onOpenSettings={() => setForceSettings(true)}
      onAuthLost={refresh}
    />
  )
}
